// extracted by mini-css-extract-plugin
module.exports = {"logotypeWrapper":"_1w703Y","small":"fxkZyG","logotype":"PJHDRs","visuallyHidden":"_1Ib0KJ"};